<div class="progress-loader" [hidden]="!loading">
    <div class="loading-spinner">
        <mat-spinner></mat-spinner>
        <span class="loading-message">Cargando...</span>
    </div>
</div>